import constants from "utils/constants";

import RoleEditor from "components/lib/Roles/RoleEditor";

import type { IdeaBusinessProfile } from "../types";

type RolesProps = { businessProfile: IdeaBusinessProfile };

export const Roles = ({ businessProfile }: RolesProps) => {
  return (
    <RoleEditor
      forType="ideaBusinessProfile"
      forId={businessProfile._id}
      permissionGroups={[
        {
          id: businessProfile._id,
          type: "ideaBusinessProfiles",
          title: "Business Profile",
          permissions: constants.permissions.ideaBusinessProfile,
        },
      ]}
      canCreateNewRoles
      canSetRolesAsDefault
    />
  );
};
